import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import FloatingActions from "../ui/FloatingActions";
import ScrollToTop from "../common/ScrollToTop";
import PageTransition from "../common/PageTransition";
import CookieBanner from "../legal/CookieBanner";

export default function Layout() {

  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-bg-surface">

      <ScrollToTop />

      <Navbar />

      <main className="flex-1 overflow-hidden">
        <PageTransition pathKey={location.pathname}>
          <Outlet />
        </PageTransition>
      </main>

      <Footer />
      <CookieBanner />
      <FloatingActions />
    </div>
  );
}